import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classnames from 'classnames';

import IconDown from './down.svg'

const Div = styled.div`
  background-color: ${({ theme }) => theme.colors.primary };
  cursor: pointer;
  display: block;
  height: 50px;
  left: calc(50vw - 36px);
  padding: 10px;
  position: fixed;
  top: calc(100vh);
  transition: transform .5s 2s;
  transform: translateZ(0);
  width: 74px;
  z-index: 10000;

  @media (max-width: 650px) {
    top: calc(100vh - 50px);
  }

  &.is-active {
    transform: translate3d(0,-50px,0);
  }
`;

const NextSlide = ({ currentSlide, setCurrentSlide, totalSlides }) => {
  const classes = ['next-slide', {'is-active': currentSlide <= totalSlides }];

  return (
      <Div href={`#slide-${currentSlide + 1 }`}
           className={ classnames(classes) }
           onClick={ () => { currentSlide < (totalSlides + 1) && setCurrentSlide(currentSlide + 1) } }
      ><IconDown /></Div>
  );
};

NextSlide.propTypes = {
  currentSlide: PropTypes.number,
  setCurrentSlide: PropTypes.func.isRequired,
  totalSlides: PropTypes.number,
};

export default NextSlide



// WEBPACK FOOTER //
// ./src/components/NextSlide/index.js